import { environment } from './../environments/environment.prod';
import { Router, NavigationEnd } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        (<any>window).gtag('config', environment.googleAnalyticsMeasurementId, {
          page_path: event.urlAfterRedirects
        });
        (<any>window).gtag('send', 'page_view');
      }
    });
  }

  track(eventName: string, eventParams?: any) {
    (<any>window).gtag('event', eventName, eventParams);
  }
}
